import { render, staticRenderFns } from "./ia-painel-lateral.vue?vue&type=template&id=b008ddea&scoped=true&"
import script from "./ia-painel-lateral.vue?vue&type=script&lang=js&"
export * from "./ia-painel-lateral.vue?vue&type=script&lang=js&"
import style0 from "./ia-painel-lateral.vue?vue&type=style&index=0&id=b008ddea&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b008ddea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b008ddea')) {
      api.createRecord('b008ddea', component.options)
    } else {
      api.reload('b008ddea', component.options)
    }
    module.hot.accept("./ia-painel-lateral.vue?vue&type=template&id=b008ddea&scoped=true&", function () {
      api.rerender('b008ddea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/global/components/ia-painel-lateral/ia-painel-lateral.vue"
export default component.exports